import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export const FUNCIONALIDADES = ['usuarios', 'professores', 'impressao', 'laboratorios', 'ativos'] as const;
export const SEVERIDADES = ['info', 'warning', 'error'] as const;

export type Funcionalidade = typeof FUNCIONALIDADES[number];
export type Severidade = typeof SEVERIDADES[number];

interface PreferenciaNotificacao {
  id: string;
  funcionalidade: string;
  severidade: string;
  ativo: boolean;
}

export const usePreferenciasNotificacao = () => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['preferencias_notificacao', user?.id],
    enabled: !!user,
    queryFn: async () => {
      const { data, error } = await (supabase as any)
        .from('preferencias_notificacao')
        .select('id, funcionalidade, severidade, ativo')
        .eq('usuario_id', user!.id);
      if (error) throw error;
      return data as PreferenciaNotificacao[];
    },
  });
};

export const useTogglePreferencia = () => {
  const qc = useQueryClient();
  const { user, tenantId } = useAuth();

  return useMutation({
    mutationFn: async ({
      funcionalidade,
      severidade,
      ativo,
    }: {
      funcionalidade: string;
      severidade: string;
      ativo: boolean;
    }) => {
      if (!user || !tenantId) throw new Error('Usuário não autenticado');

      // Upsert
      const { error } = await (supabase as any)
        .from('preferencias_notificacao')
        .upsert(
          {
            usuario_id: user.id,
            tenant_id: tenantId,
            funcionalidade,
            severidade,
            ativo,
          },
          { onConflict: 'usuario_id,funcionalidade,severidade' }
        );
      if (error) throw error;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['preferencias_notificacao'] });
    },
  });
};
